module.exports = __webpack_public_path__ + "resources/img/img_secureguard2_m.b3df8a6c85c59787107337eb038ba08c.png";